var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-card sk-widget",on:{"click":_vm.goToMenu}},[_c('div',{staticClass:"brand-image",style:(_vm.brandImageStyle)}),_c('div',{staticClass:"title text-truncate"},[_vm._v(_vm._s(_vm.brand.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }